module.exports = __webpack_public_path__ + "img/crazy-time.48d7437.png";